import { render, staticRenderFns } from "./LinkedPagesList.vue?vue&type=template&id=90d39a9e&"
import script from "./LinkedPagesList.vue?vue&type=script&lang=js&"
export * from "./LinkedPagesList.vue?vue&type=script&lang=js&"
import style0 from "./LinkedPagesList.vue?vue&type=style&index=0&id=90d39a9e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports